import {
  attachModel,
  deleteModel,
  detachModel,
  focus,
  getModel,
  getModels,
  pickModel,
  storeModel,
} from '@kanrisha/api/models';
import { ref } from 'vue';

export default function useModels(params) {
  const models = ref([]);
  const currentModel = ref([]);
  const page = ref(params.page ?? 1);
  const settings = ref(params);

  const fetchModels = async (params = {}, volatile = '') => {
    for (let key in params) {
      settings.value[key] = params[key];
    }

    models.value = await getModels(params.page ?? page.value, settings.value, volatile);
  };

  const fetchModel = async (id) => {
    currentModel.value = await getModel(id, settings.value.resourceType);
  };

  return {
    models,
    currentModel,
    focus,
    page,
    settings,
    fetchModels,
    fetchModel,
    storeModel,
    deleteModel,
    pickModel,
    attachModel,
    detachModel,
  };
}
